import { render, staticRenderFns } from "./ReviewExerciseStaffReviewer.vue?vue&type=template&id=306967db"
import script from "./ReviewExerciseStaffReviewer.vue?vue&type=script&lang=js"
export * from "./ReviewExerciseStaffReviewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports